import { Theme } from '@mui/material';
import { createStyles, StyleRules } from '@mui/styles';

const styles = (theme: Theme): StyleRules =>
    createStyles({
        root: {
            boxShadow: 'none',
            backgroundColor: '#fff',
            width: '100%',
            whiteSpace: 'nowrap',
        },
        paper: {
            width: '100%',
            height: '50px',
        },
        table: {
            backgroundColor: '#fff',
            borderCollapse: 'separate',
        },
        tableRow: (props: any) =>
            props.enableSelectRow
                ? {
                      '& th:nth-child(1), & td:nth-child(1)': {
                          backgroundColor: '#fff',
                          position: 'sticky',
                          left: '0px',
                          opacity: 1,
                          zIndex: 1,
                      },
                      '& th:nth-child(2), & td:nth-child(2)': {
                          backgroundColor: '#fff',
                          position: 'sticky',
                          left: '52px',
                          opacity: 1,
                          zIndex: 1,
                          borderRight: '1px solid rgba(224, 224, 224, 1)',
                      },
                  }
                : {
                      '& th:nth-child(1), & td:nth-child(1)': {
                          backgroundColor: '#fff',
                          position: 'sticky',
                          left: '0px',
                          opacity: 1,
                          zIndex: 1,
                          borderRight: '1px solid rgba(224, 224, 224, 1)',
                      },
                  },
        tableRowHover: {
            '&:hover': {
                backgroundColor: theme.palette.grey[200],
                cursor: 'pointer',
            },
        },
        header: {
            padding: '4px 20px',
        },
        tableCell: {
            textAlign: 'right',
            opacity: 0.87,
            padding: '4px 20px',
        },
        deletedRow: {
            backgroundColor: '#ff000011',
        },
    });

export default styles;
